import * as Types from '../../../../../__generated__/schema';

import { UserDetails } from '../../../../graphql/fragments/UserDetails.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EditUserVariables = Types.Exact<{
  input: Types.UpdateUserInput;
}>;

export type EditUser = { updateUser: { user: UserDetails } };

export const EditUserDocument = gql`
  mutation EditUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        ...UserDetails
      }
    }
  }
  ${UserDetails}
`;
export type EditUserMutationFn = Apollo.MutationFunction<EditUser, EditUserVariables>;

/**
 * __useEditUser__
 *
 * To run a mutation, you first call `useEditUser` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUser` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUser, { data, loading, error }] = useEditUser({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditUser(baseOptions?: Apollo.MutationHookOptions<EditUser, EditUserVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EditUser, EditUserVariables>(EditUserDocument, options);
}
export type EditUserHookResult = ReturnType<typeof useEditUser>;
export type EditUserMutationResult = Apollo.MutationResult<EditUser>;
export type EditUserMutationOptions = Apollo.BaseMutationOptions<EditUser, EditUserVariables>;
export function mockEditUser({
  data,
  variables,
  errors,
}: {
  data: EditUser;
  variables?: EditUserVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: EditUserDocument, variables },
    result: { data, errors },
  };
}
